import Entities from 'STORE';
import { IPushNotification } from 'STORE/PushNotifications/PushNotifications.types';

import { onNotificationClose } from '../utils/onNotificationClose';
import { onSpaceNotificationClick } from '../utils/onSpaceNotificationClick';
import { prepareNotificationOptions } from '../utils/prepareNotificationOptions';

export const handleDefaultSpaceNotification = (pushNotification: IPushNotification): void => {
  if (!pushNotification.spaceId) {
    return;
  }

  const options = prepareNotificationOptions(pushNotification);

  const notification = new Notification(pushNotification.title || '', options);
  Entities.pushNotifications.addNotification(notification);
  notification.onclick = (): Promise<void> =>
    onSpaceNotificationClick(pushNotification, notification);
  notification.onclose = (): void => onNotificationClose(notification);
  notification.onerror = (): void => onNotificationClose(notification);
};
